import { IImageMediaDto } from '@api/typings'
import { Devices } from '@styles'

export interface MediaSource<T> {
  mediaQuery: string
  source: T
}

export function matchMedia<T>(sources: MediaSource<T>[], fallback: T): T {
  const mediaSource = sources.find((s) => window.matchMedia(s.mediaQuery).matches)

  return mediaSource === undefined ? fallback : mediaSource.source
}

export function getImageUrlForDevice(imageMedia: IImageMediaDto, device: Devices): string {
  // return imageMedia.url
  // eslint-disable-next-line @typescript-eslint/ban-ts-comment
  //@ts-ignore
  switch (device) {
    case Devices.desktopL:
    case Devices.desktopM:
      return imageMedia.formats.desktopM.url
    case Devices.desktopS:
      return imageMedia.formats.desktopS.url
    case Devices.mobileL:
      return imageMedia.formats.mobileL.url
    case Devices.mobileM:
      return imageMedia.formats.mobileM.url
    case Devices.mobileS:
      return imageMedia.formats.mobileS.url
    case Devices.tablet:
      return imageMedia.formats.tablet.url
    default:
      return imageMedia.formats.desktopS.url
  }
}
